import { store } from '../redux/store';
import { setEnrollmentProduct } from '../redux/actions/enrollment';

/**
 * Utility function to initiate the enrollment process
 * Sets the product information in Redux and navigates to the enrollment page
 * 
 * @param {string} productId - The ID of the course or bundle
 * @param {string} productType - Either 'course' or 'bundle'
 * @param {function} navigate - React Router's navigate function
 * 
 * @example
 * // In a component with useNavigate:
 * import { useNavigate } from 'react-router-dom';
 * import { startEnrollment } from '@/utils/enrollment';
 * 
 * const navigate = useNavigate();
 * startEnrollment('course-123', 'course', navigate);
 */
export const startEnrollment = (productId, productType, navigate) => {
    // Validate inputs
    if (!productId || typeof productId !== 'string') {
        console.error('Invalid productId provided to startEnrollment');
        return;
    }
    
    if (productType !== 'course' && productType !== 'bundle') {
        console.error('Invalid productType provided to startEnrollment. Must be "course" or "bundle"');
        return;
    }
    
    if (typeof navigate !== 'function') {
        console.error('Invalid navigate function provided to startEnrollment');
        return;
    }
    
    // Dispatch action to set enrollment product in Redux
    store.dispatch(setEnrollmentProduct(productId, productType));
    
    // Navigate to enrollment page
    navigate('/enrollment');
};
